import React from "react";
import SwitcherTabs from "../SwitcherTabs";
import CommonSplitView from "../../CommonSplitView";

const SwitcherTabsWithSplitView = ({
  tabs,
  initialActiveTab,
  handleClick,
  state,
  isDisabled,
  swicherTabBgColor,
  splitViewtype,
}) => {
  return (
    <div className="flex  h-full  justify-between w-full  items-center  max-w-tab-width-normal gap-gap-sm   rounded-border-radius-md  pl-padding-sm pr-padding-xs bg-primary-card">
      <div className="flex   items-center gap-gap-sm flex-1 overflow-x-hidden ">
        <p className=" font-normal text-font-xs text-text-primary">Balance:</p>
        <div className="w-full rounded-border-radius-md mx-margin-sm Qsmd:rounded-none Qsmd:mx-margin-base overflow-x-auto">
          <SwitcherTabs
            tabs={tabs}
            initialActiveTab={initialActiveTab}
            isDisabled={isDisabled}
            swicherTabBgColor={swicherTabBgColor}
            splitViewtype={splitViewtype}
          />
        </div>
      </div>
      <div className="my-margin-xs h-fit hidden Qsmd:flex">
        <CommonSplitView
          handleClick={handleClick}
          state={state}
          isDisabled={isDisabled}
        />
      </div>
    </div>
  );
};

export default SwitcherTabsWithSplitView;
